import type { MaybeRef } from 'vue';

export const postKey = 'post';

export const getPostByIdKey = (id: MaybeRef<string>) => {
  return [postKey, 'post-by-id', id];
};
